// Kas & Bank — Manual Entry API helpers (2026-09-23).
import api from "@/lib/api";

export const MANUAL_KIND_LABEL = {
  penerimaan: "Penerimaan",
  pembayaran: "Pembayaran",
  transfer: "Transfer Bank",
};

/** Meta label utk field `kind` mentah entri manual di DB (termasuk transfer_out/in). */
export const MANUAL_ENTRY_KIND_LABEL = {
  penerimaan: "Penerimaan",
  pembayaran: "Pembayaran",
  transfer_out: "Transfer Keluar",
  transfer_in: "Transfer Masuk",
};

export async function listManualEntries(kind) {
  const q = kind ? `?kind=${encodeURIComponent(kind)}` : "";
  const { data } = await api.get(`/kas-bank/manual-entries${q}`);
  return Array.isArray(data) ? data : [];
}

export async function createManualEntry(payload) {
  const { data } = await api.post("/kas-bank/manual-entries", payload);
  return data;
}

export async function updateManualEntry(entryId, patch) {
  const { data } = await api.patch(`/kas-bank/manual-entries/${encodeURIComponent(entryId)}`, patch);
  return data;
}

export async function deleteManualEntry(entryId) {
  const { data } = await api.delete(`/kas-bank/manual-entries/${encodeURIComponent(entryId)}`);
  return data;
}

/** Parse movement_id manual → entryId (buat lookup ke daftar entri manual). */
export function manualIdFromMovement(movementId) {
  if (!movementId || typeof movementId !== "string") return null;
  if (!movementId.startsWith("manual:")) return null;
  return movementId.slice("manual:".length);
}
